import { Injectable } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

import { ProgrammesEndpoint } from './programmes-endpoint.service';
import { AuthService } from './auth.service';
import { Programme } from '../models/programme.model';
import { Competence } from '../models/competence.model';


@Injectable()
export class ProgrammesService {

  constructor(
    private authService: AuthService,
    private programmesEndpoint: ProgrammesEndpoint) {
  }

  getProgrammes() {
    return this.programmesEndpoint.getProgrammesEndpoint<Array<Programme>>();
  }

  getCompetencesWithProgrammeId(programmeId: number) {
    return this.programmesEndpoint.getCompetencesParProgrammeEndpoint<Array<Competence>>(programmeId);
  }

  updateProgramme(programmeId: number, programme: Programme) {
    return this.programmesEndpoint.updateProgrammeEndpoint<Programme>(programmeId, programme);
  }

  createProgramme(programme: Programme) {
    return this.programmesEndpoint.createProgrammeEndpoint<Programme>(programme);
  }

  programmeExist(code: string) {
    return this.programmesEndpoint.programmeExistEndpoint<boolean>(code);
  }

  deleteProgramme(programmeId: number) {
    return this.programmesEndpoint.deleteProgrammeEndpoint<Programme>(programmeId);
  }

  // --------- POUR LES TABLEAUX D'HARMONISATION -----------------

  getProgrammesActifs() {
    return this.programmesEndpoint.getProgrammesActifsEndpoint<Array<Programme>>();
  }

  getAllProgrammesAvecTableaux(programmeId: number) {
    return this.programmesEndpoint.getAllProgrammesAvecTableauxEndpoint<Array<Programme>>(programmeId);
  }

  getProgrammesSansTableaux(programmeId: number) {
    return this.programmesEndpoint.getProgrammesSansTableauxEndpoint<Array<Programme>>(programmeId);
  }


}
